export const LOCAL_PRICE_MAX = 1_000_000_000
export const PRICE_MAX = 50_000
